// Framework
import { PRIMARY_OUTLET, Router, UrlTree } from '@angular/router'
import { Component } from '@angular/core'

// Platform specific
import { TokenStorage } from 'shared-lib'

// SDK
import { IAuthService } from '@engineering11/auth-web'

@Component({
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})
export class AuthenticationTermsComponent {
  userId: string
  redirectPath = 'home'
  constructor(private router: Router, private tokenStorage: TokenStorage, private authService: IAuthService) {
    const user = this.tokenStorage.getItem('user')
    this.userId = user.id
  }

  /**
   *
   *
   * @memberof AuthenticationTermsComponent
   */
  onDecline(): void {
    this.authService.signOut()
  }

  /**
   *
   *
   * @memberof AuthenticationTermsComponent
   */
  onAccept(user: string): void {
    this.tokenStorage.setItem('user', user)
    /**
     * The below checks if there is a deep link on the route, if so set
     * the redirect to that. The onboarding chain should always propagate
     * the deep link forward
     */
    const urlTree: UrlTree = this.router.parseUrl(this.router.url)
    const primary = urlTree.root.children[PRIMARY_OUTLET]
    if (primary.segments.length > 1) {
      this.redirectPath = decodeURIComponent(primary.segments[primary.segments.length - 1].path || this.redirectPath)
    }
    this.router.navigate([this.redirectPath])
  }
}
